import { fetchData } from 'Utils/fetch-data';

interface UpdatePasswordPayload {
  oldPassword?: string;
  newPassword: string;
  isAdmin: boolean;
}

/**
 * Operaciones de cuenta.
 *
 * Viven bajo `/users` y no bajo `/employees` porque no son datos del empleado:
 * `/employees` sirve información, `/users` sirve autenticación y cuenta.
 */
class UsersAccountApi {
  /** `PATCH /users/:id/password` */
  async updatePassword(userId: string, payload: UpdatePasswordPayload) {
    return fetchData<{ success: boolean }>(`/users/${userId}/password`, { method: 'PATCH', data: payload });
  }
}

export const usersAccountApi = new UsersAccountApi();

export default usersAccountApi;
